import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { AuthService } from "@service/auth/auth.service";
import { Observable } from "rxjs/Observable";
import { UtilitesService } from "@systemic/services";

@Injectable()
export class AppGuard implements CanActivate {
  constructor(private lib: UtilitesService, private srvAuth: AuthService) { };
  canActivate(): Observable<boolean> {
    if (!(this.lib.TokenContext && this.lib.TokenContext.AuthServer && this.lib.TokenContext.ApiServer)) {
      this.lib.router.navigate(['/auth/login']);
      return Observable.of(false);
    } else {
      return this.srvAuth.Val_Api_Key()
        .map(res => {
          if (!res) {
            this.lib.router.navigate(['/auth/login']);
          }
          return res;
        }).catch(err => {
          this.lib.router.navigate(['/auth/login']);
          return Observable.of(false)
        });
    }
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/guard/app.guard.ts